/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import QtmColor from './Color';
import common from './common';

const purple: QtmColor = {
  50: '#f0e6fb',
  100: '#d8c1f4' /* light */,
  200: '#be98ee',
  300: '#a36be8',
  400: '#8e46e3' /* primary */,
  500: '#7718dc',
  600: '#6c11d6',
  700: '#5d00ce' /* dark */,
  800: '#4d00c8',
  900: '#2f00c0',
  contrast: {
    50: common.black,
    100: common.black,
    200: common.black,
    300: common.black,
    400: common.white,
    500: common.white,
    600: common.white,
    700: common.white,
    800: common.white,
    900: common.white,
  },
};

export default purple;
